import styles from "./styles/target-track-container.module.scss";
import UploadDragAndDrop from "@/components/common/upload-drag-and-drop";
import { audio } from "@/data/extensions";
import React from "react";
import { useAiMastering } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";
import MasteringPlayer from "@/components/pages/ai-mastering/components/mastering-player";
import deleteIcon from "@/assets/icons/delete-icon.svg";
import useMasteringModal from "@/components/pages/ai-mastering/hooks/use-mastering-modal";
import { validateMusicFile } from "@/components/pages/ai-mastering/providers/mastering";

const TargetTrackContainer = () => {
  const { setTargetTrack, targetTrack } = useAiMastering();
  const { showErrorModal } = useMasteringModal();

  if (targetTrack) {
    return (
      <MasteringPlayer
        trackUrl={URL.createObjectURL(targetTrack)}
        titles={[targetTrack.name]}
        onAction={() => setTargetTrack(undefined)}
        actionIcon={deleteIcon}
      />
    );
  }

  return (
    <div className={styles.container}>
      <p>Add Track to Master</p>
      <UploadDragAndDrop
        handleFilesAdded={async (files) => {
          const file = files[0];
          const error = await validateMusicFile(file);
          if (error) {
            showErrorModal("Uploading file error!", error);
            return;
          }

          setTargetTrack(files[0]);
        }}
        acceptedFiles={audio}
        topText={`Add Track to Master`}
        bottomText="Max file size: 200 MB, Max file duration: 12 minutes"
        isActive={true}
        isMultiple={false}
      />
    </div>
  );
};

export default TargetTrackContainer;
